import { useEffect } from "react";
import { PlusIcon } from "lucide-react";
import { useNavigate } from "react-router";

import {
  Column,
  ErrorText,
  LoadingIndicator,
  TopbarContainer,
  TopbarTitle,
} from "@/components";
import { CampaignsTable } from "@/components/tools/CampaignsTable";
import { Button } from "@/components/ui/button";

import { useSetTitle } from "@/hooks/useSetTitle";
import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_SCREENS, MIXPANEL_SUBSCREENS } from "@/lib/mixpanel/types";
import { novaClient } from "@/lib/trpc";

export const ToolsCampaignsListPage = () => {
  const navigate = useNavigate();

  const { data: campaigns, status } =
    novaClient.internal.admin.campaigns.findAll.useQuery();

  useSetTitle({
    title: "Tools | Campaigns",
  });

  useEffect(() => {
    mixpanelUtils.trackScreenView(MIXPANEL_SCREENS.CAMPAIGNS, {
      subScreenName: MIXPANEL_SUBSCREENS.LIST,
    });
  }, []);

  return (
    <Column className="h-svh">
      <TopbarContainer>
        <TopbarTitle>Campaigns</TopbarTitle>
        <Button
          className="rounded-full"
          onClick={() => {
            mixpanelUtils.trackButtonClick(
              "Create campaign",
              MIXPANEL_SCREENS.CAMPAIGNS,
            );
            void navigate("/tools/campaigns/create");
          }}
        >
          <PlusIcon className="h-4 w-4" />
          Create campaign
        </Button>
      </TopbarContainer>
      <Column className="flex-1 overflow-hidden p-6">
        {status === "pending" && <LoadingIndicator variant="medium" />}
        {status === "error" && (
          <ErrorText errorMessage="Error loading campaigns." />
        )}
        {status === "success" && <CampaignsTable campaigns={campaigns} />}
      </Column>
    </Column>
  );
};
